import { render, staticRenderFns } from "./add-follow-up-modal.vue?vue&type=template&id=70a9219e"
import script from "./add-follow-up-modal.vue?vue&type=script&lang=js"
export * from "./add-follow-up-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports